var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-toolbar"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":_vm.logo}})]),_c('label',[_c('translate',[_vm._v("Scale")]),_vm._v(" 1: "+_vm._s(_vm.scale))],1),_c('label',[_vm._v(_vm._s(_vm.project.config.projection))]),_c('label',[_c('translate',[_vm._v("Coordinates")]),_vm._v(": "),_c('span',{ref:"coords"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }